import { useContext } from "react";
import { GenerateGamesContext } from "./GenerateGamesContext";
import { getApi } from "@beeldit/core/helpers/api";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";

function useExecuteGenerateGames() {
  const { modelId } = useContext(GenerateGamesContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    getApi()
      .post(`/categories/${modelId}/generate-games`, {})
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useExecuteGenerateGames;
